import { capitalize } from '@sonar-software/sonar-ts-lib';
import { SchemaFormat } from '@sonar-software/sonar-core';
import { UpdateQueryParams } from '@hooks';

import { DynamicFilter, SonarObjectType } from '@sonar-software/sonar-ts-types';
import { FilterContainer, FilterContainerDisplay } from './FilterContainer';
import { FilterTag, FilterTagProps } from './FilterTag';
import React, { PropsWithChildren } from 'react';

export interface FilterComponentProps<T = unknown> {
	display?: FilterContainerDisplay;
	displayAsTag?: boolean;
    displayName?: string;
	id: string;
	format: SchemaFormat;
	label?: string;
	metadata?: string;
	sonarObjectId?: number | null;
	sonarObjectType?: SonarObjectType | null;
	onChange: UpdateQueryParams<DynamicFilter<T>>;
	params: DynamicFilter;
	placeholder?: string;
	value: T;
}

export type FilterComponent<T = unknown> = React.FC<FilterComponentProps<T>>;

export type FilterComponentBaseProps<T = unknown> = {
	className?: string;
	tagProps?: Partial<FilterTagProps>;
} & FilterComponentProps<T>;

export const FilterComponent: React.FC<PropsWithChildren<FilterComponentBaseProps>> = ({
	children,
	className,
	display,
	tagProps,
	...props
}) => {
	if (props.displayAsTag) {
		return (
			<FilterTag
				clearValue={ Array.isArray(props.value) ? [] : '' }
				format={ props.format }
				id={ props.id }
				label={ capitalize(props.label ?? '') }
				update={ props.onChange }
				value={ props.value as string }
				{ ...(tagProps ?? {}) } />
		);
	}

	return (
		<FilterContainer
			className={ className }
			display={ display }
			label={ props.label ?? '' }>{ children }
		</FilterContainer>
	);
};
